import * as React from 'react';
import Link from 'next/link';

import cx from 'classnames';
import CloseIcon from 'themes/playful/assets/close.svg';
import MenuIcon from 'themes/playful/assets/menu.svg';

import { useNavigation } from 'hooks/navigation/useNavigation';

import { Button } from '../Button/Button';
import { HeroImage } from '../HeroImage/HeroImage';
import { PlayfulNavigation } from './PlayfulNavigation';

import s from './PlayMinimalNavigation.module.css';

export const PlayMinimalNavigation = () => {
  const {
    isMenuOpen,
    bookUrl,
    businessName,
    renderOverlay,
    renderMenuButton,
    renderCloseButton,
    renderMenuContainer,
    isFloating,
    navigationRef,
    floatingNavRef,
  } = useNavigation({
    styles: {
      overlay: s.overlay,
      overlayOpen: s.overlayOpen,
      overlayClosed: s.overlayClosed,
      menuButton: s.menuButton,
      closeButton: s.closeButton,
      menuContainer: s.menuContainer,
      menuContainerOpen: s.menuContainerOpen,
      menuContainerClosed: s.menuContainerClosed,
    },
  });

  return (
    <nav
      ref={navigationRef}
      role="navigation"
      aria-label="main navigation"
      className={s.root}
    >
      <div className={s.topPlaceholder} ref={floatingNavRef} id="top-of-nav" />
      {renderOverlay()}
      <div className={cx(s.container, { [s.isFloating]: isFloating })}>
        <div className={s.innerContainer}>
          <div className={s.leftNavContainer}>
            <Button to={bookUrl} className={s.bookNow}>
              book now
            </Button>
          </div>

          <div className={s.businessName}>
            <Link href="/">{businessName}</Link>
          </div>
          <div className={s.rightNavContainer}>
            {renderMenuButton({ content: <MenuIcon /> })}
          </div>
        </div>
      </div>
      {renderMenuContainer({
        isOpen: isMenuOpen,
        content: (
          <div className={s.menuInnerContainer}>
            <div className={s.topContainer}>
              <Link href="/">{businessName}</Link>
              <div className={s.topRightContainer}>
                {renderCloseButton({ content: <CloseIcon /> })}
              </div>
            </div>
            <div className={s.navContainer}>
              <PlayfulNavigation />
            </div>
            <div className={s.heroContainer}>
              <HeroImage />
              <h1>
                <Link href="/">{businessName}</Link>
              </h1>
            </div>
          </div>
        ),
      })}
    </nav>
  );
};
